const MAX_RETRY_COUNT = 4;

export const roleBindingsRetryOptions = {
  retry: (failureCount: number) => failureCount < MAX_RETRY_COUNT,
  retryDelay: (failureCount: number) => (failureCount + 1) * 1_000,
} as const;
